import { render, staticRenderFns } from "./mwbj.vue?vue&type=template&id=0c176bf2&scoped=true&"
import script from "./mwbj.vue?vue&type=script&lang=js&"
export * from "./mwbj.vue?vue&type=script&lang=js&"
import style0 from "./mwbj.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mwbj.vue?vue&type=style&index=1&id=0c176bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c176bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c176bf2')) {
      api.createRecord('0c176bf2', component.options)
    } else {
      api.reload('0c176bf2', component.options)
    }
    module.hot.accept("./mwbj.vue?vue&type=template&id=0c176bf2&scoped=true&", function () {
      api.rerender('0c176bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/mwbj.vue"
export default component.exports